import {Log} from '@aboutyou/mlm';

interface Config {
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
}

export function registerServiceWorker(config?: Config) {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register(new URL('/service-worker.js', window.location.href), {
          scope: '/',
          updateViaCache: 'none',
        })
        .then(registration => {
          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (!installingWorker) {
              return;
            }

            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  if (config?.onUpdate) {
                    config.onUpdate(registration);
                  }
                } else {
                  if (config?.onSuccess) {
                    config.onSuccess(registration);
                  }
                }
              }
            };
          };
        })
        .catch(error => {
          Log.error(
            '@aboutyou/bootstrap',
            'Service worker registration failed',
            {error},
          );
        });
    });
  } else {
    if (process.env.NODE_ENV !== 'production') {
      Log.warn('@aboutyou/bootstrap', 'Service workers not supported');
    }
  }
}

export const unregisterAllServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then(registrations =>
        registrations.map(registration => registration.unregister()),
      );
  }
};
